import { MapItemData } from "../map-layers/types";

/** Guard Tours Setup */
export interface GuardTour {
	guardTourId: number,
	groupId: number,
	title: string,
	guardTourSteps: GuardTourStep[]
	guardTourTypeId: number;
	tagIds: number[] | null;
}

export interface GuardTourStep {
	guardTourId: number,
	latLong: string,
	guardTourStepId?: number,
	mapLayerId: number,
	mapLayerItemId: number,
	mapLayerItemTitle: string,
	mapLayerItemTypeId: number,
	maxElevation: number,
	minElevation: number,
	stepOrder: number,
	scriptId?: number | null
}

export interface GuardTourState {
	guardTours: GuardTour[],
	currentGuardTour: GuardTour,
	waypointMarkerPosition: string,
	creatingWaypoint: boolean,
	itemToAdd: MapItemData,
	showTour: boolean,
	loadItemsFromMap: boolean,
	mapItemList: MapItemData[],
	selectedAreaId: number,
	filterTourTypeId: number,
	assessmentTours: GuardTour[],
}

export enum GuardTourType {
	Guard = 1,
	Assessment = 2
}

export interface GuardTourTypeOption {
	label: string,
	id: number
}

export enum ManualRaiseSelectType {
	ServerTypeEvent = 1,
	AssessmentTour = 2
}

export interface AssessmentTourSelectOption {
    label: string;
    value: number;
    type: number;
    tagIds: number[];
}